/**
 * Created by mh on 2017/5/24.
 */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';
import { withRouter, NavLink } from 'react-router-dom';


@withRouter @inject('auth') @observer
class NavigationLeft extends Component {
    render() {
        return (
            <nav className="col-sm-3 col-md-2 d-none d-sm-block bg-light sidebar">
                <ul className="nav nav-pills flex-column">
                    <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            exact
                            to="/home/">
                            <FormattedMessage id="Home.Overview" defaultMessage="Overview" />
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            to="/home/jobs/">
                            <FormattedMessage id="Home.Jobs" defaultMessage="Jobs" />
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            to="/home/reports/">
                            <FormattedMessage id="Home.Reports" defaultMessage="Reports" />
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            to="/home/analytics/">
                            <FormattedMessage id="Home.Analytics" defaultMessage="Analytics" />
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            to="/home/export/">
                            <FormattedMessage id="Home.Export" defaultMessage="Export" />
                        </NavLink>
                    </li>
                </ul>

            </nav>
        );
    }
}

NavigationLeft.wrappedComponent.propTypes = {
};

export default injectIntl(NavigationLeft);
//
// <ul className="nav nav-pills flex-column">
//     <li className="nav-item">
//         <NavLink className="nav-link" activeClassName="active" to="/">Nav item</NavLink>
//     </li>
//     <li className="nav-item">
//         <NavLink className="nav-link" activeClassName="active" to="/">Nav item again</NavLink>
//     </li>
//     <li className="nav-item">
//         <NavLink className="nav-link" activeClassName="active" to="/">One more nav</NavLink>
//     </li>
//     <li className="nav-item">
//         <NavLink className="nav-link" activeClassName="active" to="/">Another nav item</NavLink>
//     </li>
// </ul>
